import axios from 'axios'
// axios.defaults.baseURL = 'http://192.168.0.122:8880/xjWechat/';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default {
    install(Vue) {
        //高德地图key
        Vue.prototype.amapKey = 'ce0aa1c960ae65b3a876d5630b521be9';
        /**
         * http post 请求
         */
        Vue.prototype.ajax = function (url, data, success, fail) {
            if (url == null) {
                return;
            }
            const origin = document.location.origin;
            url = origin + '/' + url;
            const param = [];
            for (let [key, val] of Object.entries(data)) {
                param.push(`${key}=${val}`);
            }
            axios.post(url, param.join('&')).then(res => {
                if (res.status == 200) {
                    if (res.data.code == 0) {
                        success(res.data.data);
                    } else {
                        alert(res.data.message);
                        if (typeof fail === 'function') {
                            fail(res);
                        }
                    }
                } else if (typeof fail === 'function') {
                    fail(res);
                }
            }).catch(e => {
                if (typeof fail === 'function') {
                    fail(e);
                }
            });
        };

        /**
         * 风向 角度转文字
         */
        Vue.prototype.getWindDStr = function (windD) {
            if (windD < 0) {
                windD = '';
            } else if (windD >= 348.75 || windD < 11.25) {
                windD = "北风";
            } else if (windD >= 11.25 && windD < 78.75) {
                windD = "东北风";
            } else if (windD >= 78.75 && windD < 101.25) {
                windD = "东风";
            } else if (windD >= 101.25 && windD < 168.75) {
                windD = "东南风";
            } else if (windD >= 168.75 && windD < 191.25) {
                windD = "南风";
            } else if (windD >= 191.25 && windD < 258.75) {
                windD = "西南风";
            } else if (windD >= 258.75 && windD < 281.25) {
                windD = "西风";
            } else if (windD >= 281.25 && windD < 348.75) {
                windD = "西北风";
            }
            return windD;
        };

        Vue.prototype.getBWWindDStr = function (windD) {
            let winddstr = "";
            if (windD == "1.0") {
                winddstr = "东北风";
            } else if (windD == "2.0") {
                winddstr = "东风";
            } else if (windD == "3.0") {
                winddstr = "东南风";
            } else if (windD == "4.0") {
                winddstr = "南风";
            } else if (windD == "5.0") {
                winddstr = "西南风";
            } else if (windD == "6.0") {
                winddstr = "西风";
            } else if (windD == "7.0") {
                winddstr = "西北风";
            } else if (windD == "8.0") {
                winddstr = "北风";
            } else if (windD == "9.0") {
                winddstr = "旋转不定";
            }
            return winddstr;
        };

        /**
         * 风速 速度转级别
         */
        Vue.prototype.getWindVStr = function (windV) {
            if (windV == 0) {
                windV = "无风";
            } else if (windV <= 1.5) {
                windV = "2级";
            } else if (windV >= 1.6 && windV <= 5.4) {
                windV = "2~3级";
            } else if (windV >= 5.5 && windV <= 7.9) {
                windV = "3~4级";
            } else if (windV >= 8.0 && windV <= 10.7) {
                windV = "4~5级";
            } else if (windV >= 10.8 && windV <= 13.8) {
                windV = "5~6级";
            } else if (windV >= 13.9 && windV <= 17.1) {
                windV = "6~7级";
            } else if (windV >= 17.2 && windV <= 20.7) {
                windV = "7~8级";
            } else if (windV >= 20.8 && windV <= 24.4) {
                windV = "8~9级";
            } else if (windV >= 24.5 && windV <= 28.4) {
                windV = "9~10级";
            } else if (windV >= 28.5 && windV <= 32.6) {
                windV = "10~11级";
            } else if (windV > 32.6) {
                windV = "12级";
            }
            return windV;
        }
    }
}